"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _trustpilotReviews = _interopRequireDefault(require("./components/trustpilot-reviews"));

var _default = _trustpilotReviews.default;
exports.default = _default;